<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 705.74 869.81"
  ><defs><linearGradient
    id="b"
    x1="522.49"
    y1="1571.03"
    x2="522.49"
    y2="1076.76"
    gradientTransform="translate(0 -995.1)"
    gradientUnits="userSpaceOnUse"
  ><stop
    offset="0"
    stop-color="#a96e00"
  /><stop
    offset=".54"
    stop-color="#eeb300"
  /><stop
    offset="1"
    stop-color="#e2c900"
  /></linearGradient><linearGradient
    id="c"
    x1="435.15"
    y1="1287.82"
    x2="694.35"
    y2="1287.82"
    gradientTransform="translate(0 -995.1)"
    gradientUnits="userSpaceOnUse"
  ><stop
    offset="0"
    stop-color="#e2b200"
  /><stop
    offset="1"
    stop-color="#7c4f15"
  /></linearGradient><linearGradient
    id="d"
    x1="368.16"
    y1="1486.2"
    x2="579.07"
    y2="1486.2"
    xlink:href="#c"
  /><linearGradient
    id="e"
    x1="529.04"
    y1="1257.74"
    x2="529.04"
    y2="1056.69"
    gradientTransform="translate(0 -995.1)"
    gradientUnits="userSpaceOnUse"
  ><stop
    offset="0"
    stop-color="#503c37"
  /><stop
    offset="1"
    stop-color="#888400"
  /></linearGradient><linearGradient
    id="f"
    x1="401.28"
    y1="1398.14"
    x2="410.42"
    y2="1509.24"
    gradientTransform="translate(0 -995.1)"
    gradientUnits="userSpaceOnUse"
  ><stop
    offset="0"
    stop-color="#cca626"
  /><stop
    offset="1"
    stop-color="#7c4f15"
  /></linearGradient><linearGradient
    id="g"
    x1="523.12"
    y1="1598.17"
    x2="523.12"
    y2="1377.4"
    xlink:href="#f"
  /><linearGradient
    id="h"
    x1="666.6"
    y1="1268"
    x2="616.38"
    y2="1317.08"
    xlink:href="#f"
  /><linearGradient
    id="i"
    x1="583.47"
    y1="1251.54"
    x2="583.47"
    y2="1146.25"
    xlink:href="#f"
  /><linearGradient
    id="j"
    x1="565.09"
    y1="1493.12"
    x2="503.45"
    y2="1389.25"
    xlink:href="#f"
  /><linearGradient
    id="k"
    x1="358.92"
    y1="1191.56"
    x2="432.61"
    y2="1191.56"
    gradientTransform="translate(0 -995.1)"
    gradientUnits="userSpaceOnUse"
  ><stop
    offset="0"
    stop-color="#dab11d"
  /><stop
    offset=".09"
    stop-color="#ddb730"
  /><stop
    offset="1"
    stop-color="#fff"
  /></linearGradient><linearGradient
    id="l"
    x1="596.58"
    y1="1231"
    x2="596.58"
    y2="1013.35"
    xlink:href="#k"
  /><linearGradient
    id="m"
    x1="522.81"
    y1="1757"
    x2="522.81"
    y2="416.52"
    xlink:href="#k"
  /><linearGradient
    id="n"
    x1="399.77"
    y1="1278.94"
    x2="399.77"
    y2="1067.04"
    xlink:href="#c"
  /><linearGradient
    id="o"
    x1="376.45"
    y1="1284.79"
    x2="470.04"
    y2="1041.67"
    gradientTransform="translate(0 -995.1)"
    gradientUnits="userSpaceOnUse"
  ><stop
    offset="0"
    stop-color="#000"
  /><stop
    offset=".19"
    stop-color="#302e16"
  /><stop
    offset="1"
    stop-color="#fff778"
  /></linearGradient><linearGradient
    id="p"
    x1="522.59"
    y1="1278.94"
    x2="522.59"
    y2="1067.04"
    xlink:href="#c"
  /><linearGradient
    id="q"
    x1="425.63"
    y1="1303.73"
    x2="519.22"
    y2="1060.6"
    xlink:href="#o"
  /><linearGradient
    id="r"
    x1="471.9"
    y1="1104.2"
    x2="492.73"
    y2="1104.2"
    gradientTransform="translate(0 -995.1)"
    gradientUnits="userSpaceOnUse"
  ><stop
    offset="0"
    stop-color="#fff"
  /><stop
    offset="1"
    stop-color="#f2f0ce"
  /></linearGradient><linearGradient
    id="s"
    x1="496.85"
    y1="1101.11"
    x2="510.94"
    y2="1101.11"
    xlink:href="#r"
  /><linearGradient
    id="t"
    x1="627.28"
    y1="1278.94"
    x2="627.28"
    y2="1067.04"
    xlink:href="#c"
  /><linearGradient
    id="u"
    x1="536.92"
    y1="1454.58"
    x2="604.26"
    y2="1555.03"
    xlink:href="#c"
  /><linearGradient
    id="v"
    x1="474.58"
    y1="1550.06"
    x2="474.58"
    y2="1506.7"
    xlink:href="#c"
  /><linearGradient
    id="w"
    x1="544.63"
    y1="1553.37"
    x2="544.63"
    y2="1507.93"
    xlink:href="#c"
  /><linearGradient
    id="x"
    x1="585.52"
    y1="1553.37"
    x2="585.52"
    y2="1507.93"
    xlink:href="#c"
  /><linearGradient
    id="y"
    x1="420.51"
    y1="1553.37"
    x2="420.51"
    y2="1507.93"
    xlink:href="#c"
  /><linearGradient
    id="z"
    x1="507.73"
    y1="1375.33"
    x2="255.47"
    y2="1595.62"
    xlink:href="#o"
  /><linearGradient
    id="aa"
    x1="630.35"
    y1="1411.61"
    x2="630.35"
    y2="1327.96"
    xlink:href="#c"
  /><linearGradient
    id="ab"
    x1="660.01"
    y1="1467.35"
    x2="660.01"
    y2="1380.6"
    xlink:href="#c"
  /><linearGradient
    id="ac"
    x1="549.19"
    y1="1367.89"
    x2="549.19"
    y2="1273.28"
    xlink:href="#c"
  /><linearGradient
    id="ad"
    x1="534.86"
    y1="1657.33"
    x2="513.62"
    y2="1649.93"
    xlink:href="#b"
  /><linearGradient
    id="ae"
    x1="517.07"
    y1="1619.16"
    x2="505.59"
    y2="1829.39"
    gradientTransform="translate(0 -995.1)"
    gradientUnits="userSpaceOnUse"
  ><stop
    offset="0"
    stop-color="#573415"
  /><stop
    offset=".25"
    stop-color="#de9d00"
  /><stop
    offset=".47"
    stop-color="#e4c600"
  /><stop
    offset=".71"
    stop-color="#de9d00"
  /><stop
    offset="1"
    stop-color="#e2c900"
  /></linearGradient><linearGradient
    id="af"
    x1="510.46"
    y1="1595.9"
    x2="511.64"
    y2="1606.56"
    gradientTransform="translate(0 -995.1)"
    gradientUnits="userSpaceOnUse"
  ><stop
    offset="0"
    stop-color="#be9243"
  /><stop
    offset="1"
    stop-color="#895e00"
  /></linearGradient><linearGradient
    id="ag"
    x1="541.04"
    y1="1690.01"
    x2="524.63"
    y2="1675.3"
    xlink:href="#b"
  /><linearGradient
    id="ah"
    x1="489.51"
    y1="1651.56"
    x2="522.37"
    y2="1613.18"
    xlink:href="#b"
  /><linearGradient
    id="ai"
    x1="521.48"
    y1="1667.4"
    x2="544.94"
    y2="1654.57"
    xlink:href="#b"
  /><linearGradient
    id="aj"
    x1="300.44"
    y1="1622.15"
    x2="325.63"
    y2="1096.14"
    gradientTransform="translate(-39.71 -982.09) rotate(1.61)"
    xlink:href="#b"
  /><linearGradient
    id="ak"
    x1="321.39"
    y1="1414.51"
    x2="315.46"
    y2="1172.25"
    gradientTransform="translate(-39.71 -982.09) rotate(1.61)"
    xlink:href="#c"
  /><linearGradient
    id="al"
    x1="284.05"
    y1="1753.21"
    x2="306.34"
    y2="1129.95"
    gradientTransform="translate(-39.71 -982.09) rotate(1.61)"
    xlink:href="#e"
  /><linearGradient
    id="am"
    x1="327.25"
    y1="1663.74"
    x2="313.79"
    y2="1529.2"
    gradientTransform="translate(-39.71 -982.09) rotate(1.61)"
    xlink:href="#f"
  /><linearGradient
    id="an"
    x1="318.87"
    y1="1712.26"
    x2="363.23"
    y2="913.7"
    gradientTransform="translate(-39.71 -982.09) rotate(1.61)"
    xlink:href="#k"
  /><linearGradient
    id="ao"
    x1="198.29"
    y1="1705.56"
    x2="242.65"
    y2="907"
    gradientTransform="translate(-39.71 -982.09) rotate(1.61)"
    xlink:href="#k"
  /><linearGradient
    id="ap"
    x1="250.18"
    y1="1588.81"
    x2="247.95"
    y2="1190.97"
    gradientTransform="translate(-39.71 -982.09) rotate(1.61)"
    xlink:href="#f"
  /><linearGradient
    id="aq"
    x1="288.54"
    y1="1017.19"
    x2="261.87"
    y2="1548.42"
    gradientTransform="translate(-39.71 -982.09) rotate(1.61)"
    xlink:href="#r"
  /><linearGradient
    id="ar"
    x1="319.49"
    y1="1301.1"
    x2="323.67"
    y2="1099.77"
    gradientTransform="translate(-39.71 -982.09) rotate(1.61)"
    xlink:href="#c"
  /><linearGradient
    id="as"
    x1="320.66"
    y1="1373.04"
    x2="322.93"
    y2="1119.21"
    gradientTransform="translate(-39.71 -982.09) rotate(1.61)"
    xlink:href="#o"
  /><linearGradient
    id="at"
    x1="340.11"
    y1="1361.59"
    x2="391.97"
    y2="1595.7"
    gradientTransform="translate(-39.71 -982.09) rotate(1.61)"
    gradientUnits="userSpaceOnUse"
  ><stop
    offset="0"
    stop-color="#231f20"
  /><stop
    offset="1"
    stop-color="#dcc900"
  /></linearGradient><linearGradient
    id="au"
    x1="322.76"
    y1="1400.02"
    x2="428.17"
    y2="1633.35"
    gradientTransform="translate(-39.71 -982.09) rotate(1.61)"
    xlink:href="#o"
  /><linearGradient
    id="av"
    x1="243.25"
    y1="1172.84"
    x2="262.85"
    y2="1172.84"
    xlink:href="#r"
  /><linearGradient
    id="aw"
    x1="252.54"
    y1="1197.61"
    x2="268"
    y2="1197.61"
    xlink:href="#r"
  /><linearGradient
    id="ax"
    x1="256.28"
    y1="1731.12"
    x2="235.05"
    y2="1723.71"
    xlink:href="#b"
  /><linearGradient
    id="ay"
    x1="236.39"
    y1="1691.66"
    x2="228.49"
    y2="1836.37"
    xlink:href="#ae"
  /><linearGradient
    id="az"
    x1="231.88"
    y1="1669.69"
    x2="233.07"
    y2="1680.34"
    xlink:href="#af"
  /><linearGradient
    id="ba"
    x1="262.47"
    y1="1763.79"
    x2="246.06"
    y2="1749.08"
    xlink:href="#b"
  /><linearGradient
    id="bb"
    x1="210.94"
    y1="1725.34"
    x2="243.8"
    y2="1686.97"
    xlink:href="#b"
  /><linearGradient
    id="bc"
    x1="242.91"
    y1="1741.18"
    x2="266.37"
    y2="1728.35"
    xlink:href="#b"
  /></defs><g isolation="isolate"><g id="a"><path
    d="M364.61,71.17c-6.49,4-11.67,111.21-7.1,182.74,4.57,71.53,11.67,106.54,17.76,112.63,6.09,6.09,135.96-2.03,170.46,29.42,34.5,31.45,18.77,66.46,3.55,79.65-15.22,13.19-57.83,11.16-67.98-13.19-10.15-24.35-13.31-38.56-20.1-41.6-6.79-3.04-112.82,3.55-119.41,12.68-6.6,9.13,0,56.82,15.73,89.29,15.73,32.47,83.86,59.1,132.41,69.5,7.1,1.52-5.07,29.42,6.6,37.03,11.67,7.61,31.45,6.09,36.02-5.58,4.57-11.67,2.54-21.31,5.58-25.87,3.04-4.57,88.78-3.55,131.4-54.28,42.62-50.73,46.67-150.67,17.25-209.52-29.42-58.85-119.22-77.62-147.12-85.74-27.9-8.12-21.61-39.06-17.15-41.09,4.46-2.03,149.56,3.04,163.25-3.04,13.7-6.09,19.79-122.99,13.7-133.03-6.09-10.04-309.97-15.33-334.83,0Z"
    fill="url(#b)"
  /><path
    d="M693.36,116.54c0-15.1-60.88-27.51-133.43-25.48-72.55,2.03-90.5-11.96-108.92,2.14-18.42,14.1-7.76,88.2-14.87,147.03-7.1,58.83,24.49,80.46,67.8,90.7,43.31,10.24,88.46,24.46,115.35,58.95,26.89,34.49,19.21,72.8,13.92,96.26-5.29,23.46,37.34,10.27,51.28-10.02,13.94-20.29,20.14-105.97-30.64-160.16-35.97-38.4-142.4-58.07-166.75-80.9-24.35-22.83-2.51-86.92,21.72-93.13,24.22-6.21,108.99,15.03,141.94,35.35,32.96,20.32,42.58-39.51,42.59-60.73Z"
    fill="url(#c)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M451.01,444.63c-18.4-2.05-83.36-7.06-82.85,3.59.51,10.65,34.96,62.14,92.03,81.16,57.07,19.02,107.06,8.8,116.34,5.02,9.28-3.78-8.99-32.41-20.66-32.92-11.67-.51-39.56,7.26-64.17-7.78-24.61-15.05-32-48.1-40.69-49.07Z"
    fill="url(#d)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M701.74,104.76c-6.86-18.24-47.96-23.85-142.31-19.28-94.36,4.57-147.94-9.13-163.66-1.01-8.33,4.3-24.69,42.37-39.49,71.03,1.23-44.8,4.56-82,8.33-84.33,24.86-15.33,328.74-10.04,334.83,0,1.89,3.11,2.6,16.46,2.29,33.6Z"
    fill="url(#e)"
    mix-blend-mode="color-dodge"
    opacity=".7"
  /><path
    d="M469.44,432.34c-8.3-5.71-23.16,6.74-67.29,4.71-44.14-2.02-59.36,5.59-62.9,11.17-.06-7,.76-12.26,2.53-14.72,6.6-9.13,112.63-15.73,119.41-12.69,3.18,1.42,5.56,5.3,8.24,11.52Z"
    fill="url(#f)"
    mix-blend-mode="color-dodge"
    opacity=".5"
  /><path
    d="M704.63,448.22c-3.45,36.43-14.98,71.4-35.11,95.37-42.61,50.73-128.35,49.72-131.4,54.29-.78,1.17-1.22,2.68-1.54,4.47,0,0-10.34,9.8-15.56,16.61-5.22,6.81-14.86-9.61-18.1-16.84-3.23-7.23,2.09-12.37-5.33-14.46-7.41-2.09-14.04,1.49-26.95-.1,0,0-.02,0-.02,0-45.71-12.53-99.38-36.42-113.1-64.77-7.56-15.6-13-34.72-15.9-51.37,0,0,0-.02,0-.02,16.9,30.59,52.54,74.98,104.79,91.72,52.26,16.74,106.54,23.59,167.04-5.71,50.9-24.65,82.19-70.39,91.17-109.19Z"
    fill="url(#g)"
    mix-blend-mode="color-dodge"
    opacity=".5"
  /><path
    d="M704.92,404.38c-2.55-15.07-8.23-35.15-25.01-50.53-22.72-20.83-32.21-25.87-76.73-49.84-27.27-14.68-94.36-42.23-94.36-45.66s39.11,3.51,69.88,16.61c41.09,17.5,59.77,33.2,74.34,36.02,11.79,2.28-6.1-17.25-64.16-48.11,36.09,12.58,79.18,33.8,97.88,71.2,9.95,19.9,16.07,44.51,18.16,70.31Z"
    fill="url(#h)"
    mix-blend-mode="color-dodge"
    opacity=".5"
  /><path
    d="M688.56,201.27c-.9,1.48-1.84,2.48-2.82,2.91-13.7,6.09-158.79,1.02-163.25,3.04-3.48,1.58-8.08,20.79,3.33,33-21.43-7.47-12.44-25.26-15.39-28.3s-25.2.38-30.53-3.81c-5.33-4.19,4.57-19.41,9.89-23.28,5.33-3.87,20.55,13.39,20.64,10.72.09-2.66-9.98-12.18-13.79-17.88-3.81-5.71,13.7-19.41,16.74-7.23,3.04,12.18,9.51,19.79,35.01,18.26,25.49-1.52,32.16,2.88,72.16,9.89,27.71,4.86,48.11,7.81,68.02,2.66Z"
    fill="url(#i)"
    mix-blend-mode="color-dodge"
    opacity=".5"
  /><path
    d="M573.88,463.05c-1.9,1.14-7.99-3.8-7.61-2.28.38,1.52,3.04,7.99,1.14,10.65-1.9,2.66-6.85,12.56-11.03,12.94-4.19.38-9.13-1.52-8.75,0,.38,1.52,6.47,6.47.76,8.37-5.71,1.9-46.12,3.56-61.29-21.58,15.45,15.89,49.03,15.85,62.18,4.46,15.22-13.19,30.94-48.19-3.55-79.65-6.15-5.61-15.33-9.96-26.31-13.35,19.09-.59,45.72,17.08,53.71,25.93,7.99,8.86,7.99,15.84,6.85,16.35-1.14.5-6.85,3.17-5.33,4.31,1.52,1.14,4.12,1.9,5.87,5.71,1.74,3.8-4.73,27.01-6.63,28.16Z"
    fill="url(#j)"
    mix-blend-mode="color-dodge"
    opacity=".5"
  /><path
    d="M361.19,240.23c-.72-10.42-5.71-70.02,1.9-84.74,7.61-14.72,27.01-63.42,46.8-62.28,19.79,1.14,25.81,52.55,21.31,81.81-1.52,9.89-6.85-42.61-20.55-47.94-13.7-5.33-31.96,11.41-36.91,51.75-4.95,40.33-6.85,103.49-6.85,118.33s-4.47-38.91-5.71-56.93Z"
    fill="url(#k)"
    mix-blend-mode="multiply"
    opacity=".7"
  /><path
    d="M681.94,165.56c-.56-10.18,11.41,33.43-12.18,33.05-23.59-.38-56.69-7.61-88.96-12.94-10.88-1.8-53.01-3.42-58.31-9.13-5.3-5.71-15.2-34.62-13.67-34.62s10.99,15.6,13.67,16.74c2.69,1.14,14.48-.62,15.24-3.17.76-2.54.76-19.66,2.28-17,1.52,2.66.38,14.21,4.19,17,3.81,2.79,15.22,1.78,17.88,0,2.66-1.78,7.23-20.04,7.99-13.96.76,6.09-1.52,15.98,6.09,18.26,7.61,2.28,37.67,1.9,67.35,17.88,29.68,15.98,38.81-5.22,38.43-12.12Z"
    fill="url(#l)"
    mix-blend-mode="multiply"
    opacity=".7"
  /><path
    d="M443.37,229.05c-4.82-12.44-.42,65.36-6.87,88.76-5.6,20.29-30.8,33.76-43.36,27.67-12.56-6.09-22.06-26.16-24.73-31.2-3.42-6.47-8.37,40.71,21.31,44.52,29.68,3.81,53.65-7.23,79.71-3.42,26.06,3.8,65.25,22.07,75.91,21.31,10.65-.76,48.32-24.73,46.42-21.69s-27.01,27.4-23.59,32.72c3.42,5.33,13.32,25.87,18.64,25.87s25.65-1.9,20.05,0c-5.59,1.9-12.82,3.44-7.5,6.48,5.33,3.03,15.22,31.95,19.41,33.85,4.19,1.9,18.64,6.47,13.7,7.23-4.95.76-16.36-1.14-18.26,3.04-1.9,4.19-7.61,25.87-3.42,27.4,4.19,1.52,12.94,4.95,9.89,5.33-3.04.38-11.32-1.26-12.56.51-3.91,5.57-16.99,22.07-10.91,30.44,6.09,8.37,17.5,20.55,9.65,15.09-3.17-2.2-9.22-10.92-15.87-8.55-46.53,16.54-72.67,14.26-83.58,10.96-1.92-.58,2.02-32.4.88-34.31-1.68-2.8-6.92,29.49-11.28,29.49-21.31,0-76.51-14.45-123.79-77.12-6.16-8.16,1.21,35.59,11.17,46.38,52.25,56.6,119.56,66.33,168.56,61.29,44.16-4.54,95.12-33.78,95.88-45.02.18-2.68-26.34-21.89-20.67-26.14,3.04-2.28,17.88,3.55,15.98,1.27-1.9-2.28-11.92-5.71-11.92-9.13s5.15-25.62,10.15-29.04c5-3.42,39.95-5.25,37.29-6.39-2.66-1.14-40.33-5.59-42.61-12.45-2.28-6.86-5.33-36.2-4.95-38.49.38-2.28,34.62-16.92,31.96-17.63s-30.06,12.53-33.86,7.66c-3.8-4.87-37.29-28.97-38.05-32.77-.76-3.81,12.56-17.5,12.18-19.41s-29.21,9.41-35.3,5.99c-6.09-3.42-51.03-28.4-71.62-35.67-6.47-2.28,4.19-21.69,2.28-22.07-1.9-.38-8.81,14.46-12.59,12.94-3.77-1.52-20.14-25.11-20.52-28.54-.38-3.42,12.94-8.75,13.32-11.8.38-3.04-17.88,7.61-20.93,2.28s-11.03-25.87-15.6-37.67Z"
    fill="url(#m)"
    mix-blend-mode="multiply"
    opacity=".7"
  /><path
    d="M404.34,134.69c-10.74,4.25-30.6,71.02-31.1,111.1-.51,40.08,21.82,66.97,37.54,64.94,15.73-2.03,16.23-83.76,15.22-107.83-1.01-24.07-6.28-74.3-21.66-68.21Z"
    fill="url(#n)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M404.34,149.4c-23.64,12.43-8.28,130.89,4.41,125.31,12.68-5.58,14.71-57.33,11.16-84.72-3.55-27.4-8.82-44.14-15.57-40.59Z"
    fill="url(#o)"
    mix-blend-mode="screen"
    opacity=".8"
  /><path
    d="M462.02,101.21c-20.29,9.26-23.84,107.04-14.71,114.65,9.13,7.61,43.12-72.6,56.82-77.65s94.87-24.83,98.42-32.44c3.55-7.61-111.61-17.76-140.53-4.57Z"
    fill="url(#p)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M459.99,108.52c-8.22,9.31-15.22,47.69,0,47.07,15.22-.61,33.48-30.55,65.44-39.17,31.96-8.62,25.66-17.25,8.52-18.26-17.14-1.01-60.27-5.15-73.96,10.36Z"
    fill="url(#q)"
    mix-blend-mode="screen"
    opacity=".8"
  /><path
    d="M473.62,104.25c-2.42.84-1.81,10.94-1.05,12.08.76,1.14,18.36-2.57,19.69-4.66,1.33-2.09-.38-9.8-3.14-9.99-2.76-.19-13.03,1.71-15.5,2.57Z"
    fill="url(#r)"
  /><path
    d="M497.88,101.67c-1.87.95-.95,8.57.86,9.24,1.81.67,11.7-.59,12.08-2.39.38-1.8-.1-6.84-1.62-7.32-1.52-.48-9.8-.31-11.32.46Z"
    fill="url(#s)"
  /><path
    d="M577.31,153.9c1.99,2.79,33.29,4,50.22,13.13,16.93,9.13,35.39,15.79,42.62,11.41,7.23-4.38,9.89-16.6,6.28-22.95-3.61-6.35-42.28-18.09-63.92-18.52-29.03-.58-39,11.61-35.2,16.93Z"
    fill="url(#t)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M465.06,438.14c-.41,12.06,3.55,38.99,15.47,48.12,11.92,9.13,28.41,15.47,28.28,23.08-.13,7.61-3.17,37.03-1.4,36.02,1.78-1.01,6.34-37.29,9.13-38.3,2.79-1.01,30.95-5.33,38.05-2.28,7.1,3.04,42.11,29.68,46.17,31.45,4.06,1.78-37.29-35.26-37.54-37.8s21.81-35.26,25.11-39.06c3.3-3.81,29.42-.76,35.01-.25,5.58.51-32.47-8.61-33.48-10.9-1.01-2.29.52-21.41-3.04-28.15-2.28-4.32-1.78,9.63-3.04,16.99-1.27,7.36-2.51,26.24-20.29,49.46-12.43,16.23-52,12.68-69.25-1.01-22.09-17.54-28.92-54.89-29.17-47.36Z"
    fill="url(#u)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M467.09,486.26c-6.08,2.66-24.6,19.53-21.56,23.84,3.04,4.31,38.18,24.3,46.55,27.17,4,1.37,13.82-23.62,11.54-27.68-2.28-4.06-32.12-25.27-36.53-23.34Z"
    fill="url(#v)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M518.84,514.16c-2.65,4.27-6.6,27.39-4.82,28.16s63.16-6.6,61.64-12.18c-1.52-5.58-12.18-20.29-19.53-20.29s-34.17-.72-37.29,4.31Z"
    fill="url(#w)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M571.09,497.93c-2.53,3.93,14.21,21.05,18.26,19.28,4.06-1.78,12.18-15.98,10.65-19.28-1.52-3.3-26.63-3.55-28.92,0Z"
    fill="url(#x)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M459.99,482.32c2.44,5.7-17.5,18.4-24.1,15.86-6.6-2.54-54.54-30.95-55.04-36.27-.51-5.33,11.41-19.53,28.66-17.5,17.25,2.03,47.65,31.32,50.48,37.91Z"
    fill="url(#y)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M404.34,451.26c-11.45-2.26-17.66,5.58-9.8,13.95,7.86,8.37,22.83,18.25,27.14,17.11,4.31-1.13-7.04-29.04-17.34-31.06Z"
    fill="url(#z)"
    mix-blend-mode="screen"
    opacity=".8"
  /><path
    d="M616.24,342.18c-1.82,1.77-18.1,17.76-13.62,22.83,4.49,5.07,23.26,25.37,32.39,24.86,9.13-.51,23.84-10.78,23.84-14.27s-38.81-37.12-42.61-33.42Z"
    fill="url(#aa)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M667.99,394.94c-7.93,2.32-26.38,9.64-26.38,15.22s-1.52,29.42,6.09,31.96c7.61,2.54,28.19,4.06,30.33,0,2.14-4.06-2.83-49.29-10.04-47.18Z"
    fill="url(#ab)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M594.43,328.49c-1.02,6.11-23.84,17.19-28.41,13.41-4.57-3.77-63.24-25.37-62.06-31.06,1.18-5.69,9.81-21.92,13.87-22.43,4.06-.51,77.62,33.99,76.61,40.08Z"
    fill="url(#ac)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M532.7,664.19c.32-.79-.78-2.19-1.26-2.75-7.07-8.18-30.23-6.94-38.96-5.65l-2.03-6.25c3.58-.53,35.33-4.85,46.04,7.54.11.13.22.27.33.4l2.07,9.2-6.18-2.5Z"
    fill="url(#ad)"
  /><path
    d="M511.9,845.69l-1.52-10.05-4.65,6.36c5-17.64,2.55-65.73.38-108.17-.21-4.14-.42-8.26-.62-12.31-2.36-47.45,4.52-99.39,4.81-101.57l6.54,1.85c-.07.52-7,52.89-4.7,99.02.2,4.05.41,8.16.62,12.3,2.33,45.63,4.73,92.82-.86,112.57Z"
    fill="url(#ae)"
  /><path
    d="M512.66,630.12h0c-4.62,0-8.4-3.78-8.4-8.4v-2.22c0-4.62,3.78-8.4,8.4-8.4h0c4.62,0,8.4,3.78,8.4,8.4v2.22c0,4.62-3.78,8.4-8.4,8.4Z"
    fill="url(#af)"
  /><path
    d="M524.25,696.17l1.46-5.01-4.97-.66c4.88-3.03,11.29-8.93,10.14-11.68-1.27-3.03-8.94-3.25-13.71-2.45l-.5-6.67c1.75-.3,16.54-2.56,20.36,6.54,3.81,9.08-9.98,18.19-12.78,19.93Z"
    fill="url(#ag)"
  /><path
    d="M492.47,655.79s-1.67-.12-2.72-1.97c-1.05-1.85-.37-3.94-.37-3.94,16.49-8.61,19.96-24.49,20-24.65l6.53,1.33c-.16.78-4.04,19.1-23.45,29.23Z"
    fill="url(#ah)"
  /><path
    d="M516.84,676.44s-1.36-3.66-.17-6.74c.02-.06,6.1-.44,11.39-2.54,2.23-.89,4.64-2.97,4.64-2.97,3.08-3.06,4.11-6.71,4.11-6.71.3.39,2.27,8.47,2.07,9.2-.57,2.11-3.57,4.97-7.94,6.7-6.28,2.49-13.79,3.03-14.1,3.06Z"
    fill="url(#ai)"
  /><path
    d="M97.53,234.56c-5.06,9.15-6.17,48-1.5,53.32,4.67,5.32,30.25,4.93,34.22,8.74,3.97,3.82,16.96,235.9,6.91,268.49-2.04,6.61-23.3,17.87-25.7,27.44-2.4,9.57-7.45,63.9-1.88,67.02,5.57,3.12,100.14,1.62,103.95,9.96,2.19,4.81,1.24,34.87,6.01,36.86,4.76,1.99,25.14,1.45,28.21-1.8,4.2-4.45,5.18-30.36,7.93-31.65,4.96-2.31,99.12-6.48,105.87-9.25,6.75-2.78,8.01-60.92,3.31-68.02-4.42-6.68-18.05-13.92-20.05-22.13-1.22-5.01-10.63-386.44-10.2-401.99.44-15.55-3.72-39.01-25.45-43.7-21.73-4.69-110.42-.51-118.67,2.97-8.25,3.47-80.47,81.12-92.96,103.74Z"
    fill="url(#aj)"
  /><path
    d="M308.74,419.46s6.29-224-10.77-249.68c-17.07-25.68-81.63-32.78-101.09-9.27-19.46,23.51-27.49,64.48-17.97,73.87,9.52,9.39,34.88,20.38,36.75,122.77.57,31.18,6.46,85.2,6.46,85.2,0,0,11.39-84.65,12.01-131.33.15-11.11,14.78,41.46,20.22,101.88,5.44,60.42,5.54,79.92,5.54,79.92,0,0,8.1-79.36,19.64-104.95,11.54-25.59,29.21,31.59,29.21,31.59Z"
    fill="url(#ak)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M344.04,556.68c-3.83-8.82-8.98-20.26-14.55-31.62-11.57-23.55-8.23-115.98-11.86-158.32-3.63-42.35-3.7-184.65-7.82-196.62-4.11-11.97-25.19-26.65-65.59-26.3-40.4.35-45.32,3.91-64.39,36.36-19.07,32.45-68.89,64.77-78.47,75.99-8.73,10.23-7.74,22.58-7.5,24.69-1.87-13.07-.34-39.03,3.66-46.29,12.49-22.62,84.71-100.27,92.96-103.74,8.25-3.47,96.93-7.65,118.67-2.97,21.73,4.69,25.89,28.15,25.45,43.7-.38,13.68,6.86,310.5,9.43,385.13Z"
    fill="url(#al)"
    mix-blend-mode="color-dodge"
    opacity=".7"
  /><path
    d="M367.3,635.7c-.76,14.1-2.69,26.73-5.75,27.99-4.91,2.02-56.06,4.78-85.5,7.01-2.72-2.41-7.69-5.34-15.37-4.66-12.63,1.13-17.29,8.78-18.15,12.83-.86,4.05-4.9,16.17-13.02,14.83s-10.64-16.97-13.06-23.34-9.81-7.86-25.03-5.97h-.02c-29.37-2.71-77.9-2.6-81.84-4.81-3.24-1.82-2.88-20.97-1.55-38.56h0s5.03,17.59,23.94,22.89c4.41,1.24,36.62-24.17,81.06-22.92,44.43,1.25,100.94,8.02,109.92,18.28,8.98,10.26,23.66,15.12,30.4,12.71,6.74-2.4,13.95-16.27,13.95-16.27Z"
    fill="url(#am)"
    mix-blend-mode="color-dodge"
    opacity=".5"
  /><path
    d="M238.82,358.1c-3.03,2.55-4.21,96.97-12.99,145.64-8.78,48.67-31.35,95.96-54.15,116.07,0,0,81.08-13.9,137.61,8.81,0,0-29.12-18.61-46.61-99.63-17.49-81.03-16.77-176.87-23.86-170.89Z"
    fill="url(#an)"
    mix-blend-mode="multiply"
    opacity=".7"
  /><path
    d="M155.05,218.39c-5.36,5.64-53.76,40.36-55.52,50.32-1.76,9.96.19,19.65,4.99,20.15,4.8.51,24.7-8.57,33.12-5,8.42,3.57,7.17,8.72,7.17,8.72,0,0-8.02,4.22-8.94,6.17,0,0,7.58-1.64,9.7-2.44,0,0,1.2,10.16,1.04,15.59,0,0-9.04,5.18-9.06,5.92-.02.74,9.54-.97,9.54-.97,0,0,10.69,164.71,6.98,208.58-3.7,43.87-5.23,45.37-5.82,46.84-.6,1.47-7.45-5.21-7.45-5.21,0,0,2.94,7.31,2.51,9.71-.44,2.4-2.68,2.89-4.15,2.66-1.48-.23-6.87-5.94-6.9-5.01-.03.93,2.37,8.03,1.23,8.93-1.14.89-16.59,5.83-19.96,11.3-3.37,5.47-2.88,23.45-2.88,23.45,0,0,1.13-13.68,7.71-17.2,6.58-3.52,13.28-4.26,14.52-2.37,1.24,1.89,6.01,17.03,6.93,17.06.93.03-4.3-18.28-3.32-20.29.98-2.01,12.75-5.2,14.96-4.77,0,0,9.17,9.89,11.52,12.18,0,0-5.78-12.02-5.69-15.17,0,0,12.5-7.43,15.78-16.42,3.28-8.99,3.43-121.88,2.48-158.47-.95-36.59-5.98-95.03-7.11-107.42,0,0,12.12-9.29,15.75-15.37,0,0-13.25,5.56-17.56,9.64,0,0-4.5-6.8-6.28-13.76,0,0,8.18-9.65,13.27-14.94,0,0-11.78,6.09-17,7.18-5.22,1.09-30.5-4.81-33.31-10.32-2.81-5.51,4.17-15.2,19.25-20.71,15.08-5.51,26.65-3.95,26.65-3.95,0,0,.84-38.52,10.43-54.8,0,0-14,19.06-24.57,30.19Z"
    fill="url(#ao)"
    mix-blend-mode="multiply"
    opacity=".7"
  /><path
    d="M130.13,261.04c-2.54,7.88,20.37,13.54,29.32,11.57,8.95-1.97,16.77-3.65,20.14-4.54,0,0-15.25,15.05-15.34,18.38,0,0,.97,7.32,3.83,8.63,0,0,19.15-9.1,22.49-9,0,0-13.88,17.16-17.67,22.11,0,0,7.01,80.24,9.26,118.84,2.25,38.6-8.49,143.91-3.01,146.66,5.48,2.75,34.4-103.16,34-128.74-.39-25.58-11.28-112.97-11.07-133.72.21-20.75-3.09-61.6-23.05-63.27-19.96-1.67-45.78,3.36-48.91,13.08Z"
    fill="url(#ap)"
    mix-blend-mode="color-dodge"
    opacity=".5"
  /><path
    d="M191.11,504.37c-3.21,7.25,2.63-67,.39-106.22-2.48-43.55-10.53-86.76-7.86-89.65,2.68-2.89,9.77-17.88,10.38-13.42.62,4.46,13.32,119.33,10.65,148.53-2.67,29.2-10,52.71-13.57,60.76Z"
    fill="url(#aq)"
  /><path
    d="M205.78,166.82c-3.2,12.88,10.98,22.42,13.87,48.19,2.48,22.09,4.34,99.44,29.6,97.18,25.26-2.25,39.54-51.92,41.99-71.45,3.18-25.36,7.85-58.08-8.06-78.54-7.64-9.82-70.55-22.91-77.4,4.62Z"
    fill="url(#ar)"
    mix-blend-mode="color-dodge"
    opacity=".3"
  /><path
    d="M230.58,159.33c-16.26,9.12-15.62,16.4-8.96,28.81s13.69,75.49,16.38,98.54c2.69,23.05,30.04-.67,39.84-33.18,9.81-32.5,1.01-81.24-8.65-87.87-11.27-7.73-27.57-12.5-38.61-6.31Z"
    fill="url(#as)"
    mix-blend-mode="screen"
    opacity=".8"
  /><path
    d="M281.28,447.49c-16.62,3.84-26.54,82.76.74,131.94,27.28,49.19,43.04,33.33,43.8,23.96.76-9.37-27.53-75.38-32.08-106.64-4.56-31.26-1.01-51.91-12.45-49.27Z"
    fill="url(#at)"
    mix-blend-mode="color-dodge"
    opacity=".2"
  /><path
    d="M287.37,511.89c-12.54,5.43,5.96,86.03,24.46,86.63,17.06.56-1.98-25.23-8.8-46.17-6.82-20.94-8.16-43.71-15.66-40.46Z"
    fill="url(#au)"
    mix-blend-mode="screen"
    opacity=".8"
  /><path
    d="M243.42,167.91c-1.28,5.08,5.01,24.85,7.12,25.4,2.11.55,11.38-4.13,12.22-7.56.84-3.44-4.31-22.36-7.25-23.43-2.93-1.07-11.35,2.65-12.1,5.59Z"
    fill="url(#av)"
  /><path
    d="M252.92,198.6c-1.27,2.42.83,11.09,3.51,12.42,2.68,1.34,11.2-2.9,11.53-5.84.33-2.94-1.03-11.38-2.82-11.43-1.79-.05-10.8,2.17-12.21,4.84Z"
    fill="url(#aw)"
  /><path
    d="M254.12,737.97c.32-.79-.78-2.19-1.26-2.75-7.07-8.18-30.23-6.94-38.96-5.65l-2.03-6.25c3.58-.53,35.33-4.85,46.04,7.54.11.13.22.27.33.4l2.07,9.2-6.18-2.5Z"
    fill="url(#ax)"
  /><path
    d="M233.33,849.14l-1.52-6.92-4.65,4.38c5-12.14,2.55-45.26.38-74.47-.21-2.85-.42-5.68-.62-8.48-2.36-32.66,4.52-68.42,4.81-69.93l6.54,1.28c-.07.36-7,36.41-4.7,68.17.2,2.79.41,5.62.62,8.47,2.33,31.42,4.73,63.9-.86,77.5Z"
    fill="url(#ay)"
  /><path
    d="M234.08,703.9h0c-4.62,0-8.4-3.78-8.4-8.4v-2.22c0-4.62,3.78-8.4,8.4-8.4h0c4.62,0,8.4,3.78,8.4,8.4v2.22c0,4.62-3.78,8.4-8.4,8.4Z"
    fill="url(#az)"
  /><path
    d="M245.68,769.95l1.46-5.01-4.97-.66c4.88-3.03,11.29-8.93,10.14-11.68-1.27-3.03-8.94-3.25-13.71-2.45l-.5-6.67c1.75-.3,16.54-2.56,20.36,6.54,3.81,9.08-9.98,18.2-12.78,19.93Z"
    fill="url(#ba)"
  /><path
    d="M213.9,729.57s-1.67-.12-2.72-1.97c-1.05-1.85-.37-3.94-.37-3.94,16.49-8.61,19.96-24.49,20-24.65l6.53,1.33c-.16.78-4.04,19.1-23.45,29.23Z"
    fill="url(#bb)"
  /><path
    d="M238.27,750.22s-1.36-3.66-.17-6.74c.02-.06,6.1-.44,11.39-2.54,2.23-.89,4.64-2.97,4.64-2.97,3.08-3.06,4.11-6.71,4.11-6.71.3.39,2.27,8.47,2.07,9.2-.57,2.11-3.57,4.97-7.94,6.7-6.28,2.49-13.79,3.03-14.1,3.06Z"
    fill="url(#bc)"
  /></g></g></svg>
</template>
